<template>
  <div>
    <ts-card>
      <div
        class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
      >
        <h4 class="ts-text-sm">
          {{ $t('school.academic.setup.program.grade.subjectOutline') }}
        </h4>
        <ts-modal-close-button />
      </div>
      <ts-card-wrapper>
        <ts-loading-banner :loading="ready_fetch">
          <div class="row">
            <div class="ts-overflow-auto" style="margin:auto;">
              <div class="tree">
                <ul>
                  <li>
                    <a href="#">
                      <select
                        v-model="model.acp_id"
                        class="form-control"
                        @change="onMainProgramChange(model.acp_id)"
                        @input="model.acps_id = model.level_id = ''"
                      >
                        <option
                          value=""
                          disabled
                          selected
                          style="display: none;"
                          >{{
                            $t(
                              'school.academic.setup.program.grade.chooseMainProgram'
                            )
                          }}</option
                        >
                        <option
                          v-for="program in main_programs"
                          :value="program.acp_id"
                          :key="program.acp_id"
                        >
                          {{ program.acp_name_foreign }}
                        </option>
                      </select>
                    </a>
                    <ul>
                      <li>
                        <a href="#">
                          <ts-loading-banner :loading="fetchSub">
                            <select
                              v-model="model.acps_id"
                              class="form-control"
                              @change="onSubProgramChange(model.acps_id)"
                              @input="model.level_id = ''"
                            >
                              <option
                                value=""
                                disabled
                                selected
                                style="display: none;"
                                >{{
                                  $t(
                                    'school.academic.setup.program.grade.chooseSubProgram'
                                  )
                                }}</option
                              >
                              <option
                                v-for="sub_program in sub_programs"
                                :value="sub_program.acps_id"
                                :key="sub_program.acps_id"
                              >
                                {{ sub_program.acps_name_foreign }}
                              </option>
                            </select>
                          </ts-loading-banner>
                        </a>
                        <ul>
                          <li>
                            <a href="#">
                              <ts-loading-banner :loading="fetchLevel">
                                <select
                                  v-model="model.level_id"
                                  class="form-control"
                                  @change="getSubjects"
                                >
                                  <option
                                    value=""
                                    disabled
                                    selected
                                    style="display: none;"
                                    >{{
                                      $t(
                                        'school.academic.setup.program.grade.chooseLevel'
                                      )
                                    }}</option
                                  >
                                  <option
                                    v-for="level in levels"
                                    :value="level.level_id"
                                    :key="level.level_id"
                                  >
                                    {{ level.level_name_foreign }}
                                  </option>
                                </select>
                              </ts-loading-banner>
                            </a>
                            <ul>
                              <li>
                                <a href="#">YEAR I</a>
                                <ul
                                  v-show="
                                    model.details.year1.semester1.subject_id
                                      .length ||
                                      model.details.year1.semester2.subject_id
                                        .length
                                  "
                                >
                                  <li>
                                    <a href="#">SEMESTER I</a>
                                    <ul
                                      v-show="
                                        model.details.year1.semester1.subject_id
                                          .length
                                      "
                                    >
                                      <li>
                                        <a href="#" class="text-left">
                                          <div
                                            v-for="subject in model.details
                                              .year1.semester1.subject_id"
                                            :key="subject.subject_id"
                                          >
                                            <span
                                              ><i class="far fa-dot-circle"></i>
                                              {{
                                                subject.subject_name_foreign
                                              }}</span
                                            >
                                          </div>
                                        </a>
                                      </li>
                                    </ul>
                                  </li>
                                  <li>
                                    <a href="#">SEMESTER II</a>
                                    <ul
                                      v-show="
                                        model.details.year1.semester2.subject_id
                                          .length
                                      "
                                    >
                                      <li>
                                        <a href="#" class="text-left">
                                          <div
                                            v-for="subject in model.details
                                              .year1.semester2.subject_id"
                                            :key="subject.subject_id"
                                          >
                                            <span
                                              ><i class="far fa-dot-circle"></i>
                                              {{
                                                subject.subject_name_foreign
                                              }}</span
                                            >
                                          </div>
                                        </a>
                                      </li>
                                    </ul>
                                  </li>
                                </ul>
                              </li>
                              <li>
                                <a href="#">YEAR II</a>
                                <ul
                                  v-show="
                                    model.details.year2.semester1.subject_id
                                      .length ||
                                      model.details.year2.semester2.subject_id
                                        .length
                                  "
                                >
                                  <li>
                                    <a href="#">SEMESTER I</a>
                                    <ul
                                      v-show="
                                        model.details.year2.semester1.subject_id
                                          .length
                                      "
                                    >
                                      <li>
                                        <a href="#" class="text-left">
                                          <div
                                            v-for="subject in model.details
                                              .year2.semester1.subject_id"
                                          >
                                            <span
                                              ><i class="far fa-dot-circle"></i>
                                              {{
                                                subject.subject_name_foreign
                                              }}</span
                                            >
                                          </div>
                                        </a>
                                      </li>
                                    </ul>
                                  </li>
                                  <li>
                                    <a href="#">SEMESTER II</a>
                                    <ul
                                      v-show="
                                        model.details.year2.semester2.subject_id
                                          .length
                                      "
                                    >
                                      <li>
                                        <a href="#" class="text-left">
                                          <div
                                            v-for="subject in model.details
                                              .year2.semester2.subject_id"
                                          >
                                            <span
                                              ><i class="far fa-dot-circle"></i>
                                              {{
                                                subject.subject_name_foreign
                                              }}</span
                                            >
                                          </div>
                                        </a>
                                      </li>
                                    </ul>
                                  </li>
                                </ul>
                              </li>
                              <li>
                                <a href="#">YEAR III</a>
                                <ul
                                  v-show="
                                    model.details.year3.semester1.subject_id
                                      .length ||
                                      model.details.year3.semester2.subject_id
                                        .length
                                  "
                                >
                                  <li>
                                    <a href="#">SEMESTER I</a>
                                    <ul
                                      v-show="
                                        model.details.year3.semester1.subject_id
                                          .length
                                      "
                                    >
                                      <li>
                                        <a href="#" class="text-left">
                                          <div
                                            v-for="subject in model.details
                                              .year3.semester1.subject_id"
                                          >
                                            <span
                                              ><i class="far fa-dot-circle"></i>
                                              {{
                                                subject.subject_name_foreign
                                              }}</span
                                            >
                                          </div>
                                        </a>
                                      </li>
                                    </ul>
                                  </li>
                                  <li>
                                    <a href="#">SEMESTER II</a>
                                    <ul
                                      v-show="
                                        model.details.year3.semester2.subject_id
                                          .length
                                      "
                                    >
                                      <li>
                                        <a href="#" class="text-left">
                                          <div
                                            v-for="subject in model.details
                                              .year3.semester2.subject_id"
                                          >
                                            <span
                                              ><i class="far fa-dot-circle"></i>
                                              {{
                                                subject.subject_name_foreign
                                              }}</span
                                            >
                                          </div>
                                        </a>
                                      </li>
                                    </ul>
                                  </li>
                                </ul>
                              </li>
                              <li>
                                <a href="#">YEAR IV</a>
                                <ul
                                  v-show="
                                    model.details.year4.semester2.subject_id
                                      .length
                                  "
                                >
                                  <li>
                                    <a href="#">SEMESTER I</a>
                                    <ul
                                      v-show="
                                        model.details.year4.semester1.subject_id
                                          .length
                                      "
                                    >
                                      <li>
                                        <a href="#" class="text-left">
                                          <div
                                            v-for="subject in model.details
                                              .year4.semester1.subject_id"
                                          >
                                            <span
                                              ><i class="far fa-dot-circle"></i>
                                              {{
                                                subject.subject_name_foreign
                                              }}</span
                                            >
                                          </div>
                                        </a>
                                      </li>
                                    </ul>
                                  </li>
                                  <li>
                                    <a href="#">SEMESTER II</a>
                                    <ul
                                      v-show="
                                        model.details.year4.semester2.subject_id
                                          .length
                                      "
                                    >
                                      <li>
                                        <a href="#" class="text-left">
                                          <div
                                            v-for="subject in model.details
                                              .year4.semester2.subject_id"
                                          >
                                            <span
                                              ><i class="far fa-dot-circle"></i>
                                              {{
                                                subject.subject_name_foreign
                                              }}</span
                                            >
                                          </div>
                                        </a>
                                      </li>
                                    </ul>
                                  </li>
                                </ul>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'grade-form',
  data () {
    return {
      sub_programs: [],
      levels: [],
      model: {
        acp_id: '',
        acps_id: '',
        level_id: '',
        details: {
          year1: {
            semester1: {
              subject_id: []
            },
            semester2: {
              subject_id: []
            }
          },
          year2: {
            semester1: {
              subject_id: []
            },
            semester2: {
              subject_id: []
            }
          },
          year3: {
            semester1: {
              subject_id: []
            },
            semester2: {
              subject_id: []
            }
          },
          year4: {
            semester1: {
              subject_id: []
            },
            semester2: {
              subject_id: []
            }
          }
        }
      },
      subjects: [],
      subject_loading: false,
      ready_fetch: false,
      fetchSub: false,
      fetchLevel: false
    }
  },
  computed: {
    ...mapState('grade', ['main_programs'])
  },
  created () {
    this.fetchResourceBeforeCreate()
  },
  methods: {
    fetchResourceBeforeCreate () {
      this.ready_fetch = true
      this.$store
        .dispatch('grade/dataBeforeCreate')
        .then(() => {
          this.ready_fetch = false
        })
        .catch(error => {
          this.ready_fetch = false
          this.$toasted.error(error.message)
        })
    },
    onMainProgramChange (acp_id) {
      this.fetchSub = true
      this.$store
        .dispatch('grade/getSubProgram', acp_id ? acp_id : 0)
        .then(response => {
          this.sub_programs = response.data
          this.fetchSub = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    async onSubProgramChange (acps_id) {
      this.fetchLevel = true
      let level = await this.$store.dispatch(
        'grade/getLevel',
        acps_id ? acps_id : 0
      )
      this.levels = level.data
      this.fetchLevel = false
    },
    async getSubjects () {
      this.clearSubject()
      if (
        this.model.acp_id == '' ||
        this.model.acps_id == '' ||
        this.model.level_id == ''
      )
        return
      this.subjects = []
      let response = await this.$store.dispatch('grade/getSubjectOutline', {
        level_id: this.model.level_id
      })
      this.subjects = response
      if (this.subjects.length > 0) {
        this.setShow()
      }
    },
    clearSubject () {
      this.model.details.year1.semester1.subject_id = []
      this.model.details.year1.semester2.subject_id = []
      this.model.details.year2.semester1.subject_id = []
      this.model.details.year2.semester2.subject_id = []
      this.model.details.year3.semester1.subject_id = []
      this.model.details.year3.semester2.subject_id = []
      this.model.details.year4.semester1.subject_id = []
      this.model.details.year4.semester2.subject_id = []
    },
    setShow () {
      if (this.subjects === null || this.subjects === undefined) return
      this.subjects.map(subj => {
        if (subj.years === 'YEAR I' && subj.terms === 'SEMESTER I') {
          this.model.details.year1.semester1.subject_id.push({
            subject_id: parseInt(subj.subject_id),
            subject_name_foreign: subj.subject.subject_name_foreign
          })
        } else if (subj.years === 'YEAR I' && subj.terms === 'SEMESTER II') {
          this.model.details.year1.semester2.subject_id.push({
            subject_id: parseInt(subj.subject_id),
            subject_name_foreign: subj.subject.subject_name_foreign
          })
        } else if (subj.years === 'YEAR II' && subj.terms === 'SEMESTER I') {
          this.model.details.year2.semester1.subject_id.push({
            subject_id: parseInt(subj.subject_id),
            subject_name_foreign: subj.subject.subject_name_foreign
          })
        } else if (subj.years === 'YEAR II' && subj.terms === 'SEMESTER II') {
          this.model.details.year2.semester2.subject_id.push({
            subject_id: parseInt(subj.subject_id),
            subject_name_foreign: subj.subject.subject_name_foreign
          })
        } else if (subj.years === 'YEAR III' && subj.terms === 'SEMESTER I') {
          this.model.details.year3.semester1.subject_id.push({
            subject_id: parseInt(subj.subject_id),
            subject_name_foreign: subj.subject.subject_name_foreign
          })
        } else if (subj.years === 'YEAR III' && subj.terms === 'SEMESTER II') {
          this.model.details.year3.semester2.subject_id.push({
            subject_id: parseInt(subj.subject_id),
            subject_name_foreign: subj.subject.subject_name_foreign
          })
        } else if (subj.years === 'YEAR IV' && subj.terms === 'SEMESTER I') {
          this.model.details.year4.semester1.subject_id.push({
            subject_id: parseInt(subj.subject_id),
            subject_name_foreign: subj.subject.subject_name_foreign
          })
        } else {
          this.model.details.year4.semester2.subject_id.push({
            subject_id: parseInt(subj.subject_id),
            subject_name_foreign: subj.subject.subject_name_foreign
          })
        }
      })
    }
  }
}
</script>
<style scoped>
.tree {
  width: max-content;
}

/*Now the CSS*/
.tree ul {
  margin: 0;
  padding: 0;
  padding-top: 20px;
  position: relative;

  transition: all 0.5s;
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
}

.tree li {
  float: left;
  text-align: center;
  list-style-type: none;
  position: relative;
  padding: 20px 2px 0 2px;

  transition: all 0.5s;
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
}

/*We will use ::before and ::after to draw the connectors*/

.tree li::before,
.tree li::after {
  content: '';
  position: absolute;
  top: 0;
  right: 50%;
  border-top: 1px solid #ccc;
  width: 50%;
  height: 20px;
}
.tree li::after {
  right: auto;
  left: 50%;
  border-left: 1px solid #ccc;
}

/*We need to remove left-right connectors from elements without 
  any siblings*/
.tree li:only-child::after,
.tree li:only-child::before {
  display: none;
}

/*Remove space from the top of single children*/
.tree li:only-child {
  padding-top: 0;
}

/*Remove left connector from first child and 
  right connector from last child*/
.tree li:first-child::before,
.tree li:last-child::after {
  border: 0 none;
}
/*Adding back the vertical connector to the last nodes*/
.tree li:last-child::before {
  border-right: 1px solid #ccc;
  border-radius: 0 5px 0 0;
  -webkit-border-radius: 0 5px 0 0;
  -moz-border-radius: 0 5px 0 0;
}
.tree li:first-child::after {
  border-radius: 5px 0 0 0;
  -webkit-border-radius: 5px 0 0 0;
  -moz-border-radius: 5px 0 0 0;
}

/*Time to add downward connectors from parents*/
.tree ul ul::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  border-left: 1px solid #ccc;
  width: 0;
  height: 20px;
}

.tree li a {
  border: 1px solid #ccc;
  padding: 6px 6px;
  text-decoration: none;
  color: #666;
  font-family: arial, verdana, tahoma;
  font-size: 10px;
  white-space: normal;
  display: inline-block;

  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;

  transition: all 0.5s;
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
}

/*Time for some hover effects*/
/*We will apply the hover effect the the lineage of the element also*/
.tree li a:hover,
.tree li a:hover + ul li a {
  background: #c8e4f8;
  color: #000;
  border: 1px solid #94a0b4;
}
/*Connector styles on hover*/
.tree li a:hover + ul li::after,
.tree li a:hover + ul li::before,
.tree li a:hover + ul::before,
.tree li a:hover + ul ul::before {
  border-color: #94a0b4;
}

::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #f0f3f4;
}
div::-webkit-scrollbar-thumb:hover {
  background: #dddedf;
}

/* This is to remove the arrow of select element in IE */
select::-ms-expand {
  display: none;
}
select {
  border: none;
  -webkit-appearance: none;
  appearance: none;
  text-align: center;
  text-align-last: center;
}

option {
  text-align: left;
}

/*Thats all. I hope you enjoyed it.
  Thanks :)*/
</style>
